import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  select: {
    width: '320px',
    borderRadius: '16px',
    marginBottom: '28px',
  },
}));
